import { render } from "./ModalIncidence_zones.vue?vue&type=template&id=be375362"
import script from "./ModalIncidence_zones.vue?vue&type=script&lang=js"
export * from "./ModalIncidence_zones.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__